import { SignIn, SignedIn, SignedOut, useClerk, useUser } from "@clerk/clerk-react";
import { Link } from "react-router";
import { Button } from "@web/components/ui/button.tsx";
import { clerkAppearance } from "./clerkAppearance.ts";

/**
 * Dedicated `/sign-in` page — open this URL anytime to switch Clerk accounts.
 * Works while signed out (Clerk form) and while signed in (switch / continue).
 */
export function SignInPage() {
  return (
    <div className="flex h-full min-h-0 flex-col items-center justify-center gap-8 bg-bg p-6">
      <div className="text-center">
        <h1 className="text-2xl font-bold tracking-tight text-text">CoyKoi</h1>
        <p className="mt-2 text-sm text-muted">Sign in to open your library</p>
      </div>

      <SignedOut>
        <SignIn
          routing="path"
          path="/sign-in"
          forceRedirectUrl="/"
          signUpForceRedirectUrl="/"
          appearance={clerkAppearance}
        />
      </SignedOut>

      <SignedIn>
        <SignedInPanel />
      </SignedIn>
    </div>
  );
}

function SignedInPanel() {
  const { user } = useUser();
  const { signOut } = useClerk();
  const email = user?.primaryEmailAddress?.emailAddress;
  const name = user?.fullName;

  return (
    <div className="w-full max-w-md space-y-4 rounded-lg border border-line bg-panel px-5 py-5">
      <div>
        <p className="text-xs font-semibold tracking-wider text-faint uppercase">
          Signed in
        </p>
        <p className="mt-1 text-base font-semibold text-text">
          {name || email || "Account"}
        </p>
        {name && email ? <p className="mt-0.5 text-sm text-muted">{email}</p> : null}
      </div>
      <div className="flex flex-col gap-2">
        <Button asChild className="w-full">
          <Link to="/liked">Continue to library</Link>
        </Button>
        <Button
          variant="ghost"
          className="w-full text-muted"
          onClick={() => void signOut({ redirectUrl: "/sign-in" })}
        >
          Switch account
        </Button>
      </div>
      <p className="text-xs text-faint">
        Bookmark{" "}
        <Link to="/sign-in" className="text-accent hover:underline">
          /sign-in
        </Link>{" "}
        to change Clerk users anytime.
      </p>
    </div>
  );
}
